import React from 'react';

/**
 * Hook que monitora mudanças de zoom na janela do navegador
 * Útil para reagir a mudanças de zoom que podem afetar o layout
 */
const useZoomDetection = () => {
    const [zoomLevel, setZoomLevel] = React.useState(1);
    
    React.useEffect(() => {
        const updateZoomLevel = () => {
            // Calcula o nível de zoom baseado na relação entre as dimensões
            const zoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100) / 100;
            setZoomLevel(zoomLevel);
        };

        // Atualiza o zoom inicial
        updateZoomLevel();

        // Monitora mudanças de tamanho da janela (incluindo zoom)
        const handleResize = () => {
            updateZoomLevel();
        };

        // Monitora mudanças específicas de zoom via wheel (Chrome/Firefox)
        const handleWheel = (event) => {
            if (event.ctrlKey || event.metaKey) {
                // Pequeno delay para aguardar o zoom ser aplicado
                setTimeout(updateZoomLevel, 100);
            }
        };

        // Monitora mudanças via keyboard (Ctrl+/- ou Cmd+/-)
        const handleKeydown = (event) => {
            if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.key === '0')) {
                setTimeout(updateZoomLevel, 100);
            }
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('wheel', handleWheel, { passive: false });
        window.addEventListener('keydown', handleKeydown);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('wheel', handleWheel);
            window.removeEventListener('keydown', handleKeydown);
        };
    }, []);

    return {
        zoomLevel,
        isZoomed: zoomLevel !== 1
    };
};

export default useZoomDetection;
